export default __webpack_public_path__ + "locales/lo-LA/UploadPanel.json?hash=7e493e94a666177efa14bce00d65b8e0";